import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { offlineSiteOf } from '../data/offline-site.model';

/**
 * Pastille « Site offline · {nom} » (inside + integrator). Violet : c'est la couleur des sites
 * locaux dans l'app mobile. Ne rend rien hors site offline.
 */
@Component({
  selector: 'lib-offline-site-badge',
  standalone: true,
  imports: [TranslocoModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (offlineSite(); as site) {
      <span
        class="inline-flex max-w-full items-center gap-1 truncate rounded-full bg-violet-100 px-2 py-0.5 text-[11px] font-semibold text-violet-700 dark:bg-violet-500/20 dark:text-violet-300"
        [title]="'offlineSite.badgeTitle' | transloco: { name: site.name }">
        <span class="size-1.5 shrink-0 rounded-full bg-violet-500" aria-hidden="true"></span>
        <span class="truncate">{{ 'offlineSite.badge' | transloco: { name: site.name } }}</span>
      </span>
    }
  `,
  host: { class: 'contents' },
})
export class OfflineSiteBadgeComponent {
  /** Tracker (inside `Tracker` ou `IntegratorTracker`) : le champ n'est pas encore dans les clients générés. */
  tracker = input<unknown>(null);
  offlineSite = computed(() => offlineSiteOf(this.tracker()));
}
